export default __webpack_public_path__ + "static/media/leaderboard.be58060b.svg";